import type { GetUsersResponse } from '@weft/api-definition';
import { GetUsersResponseSchema } from '@weft/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useUsers(options?: CustomUseQueryOptions<GetUsersResponse>) {
  return useQuery({
    queryKey: ['users'],
    queryFn: async () => {
      const api = getPrivateApi();

      const usersResponse = await api.getUsers();

      return GetUsersResponseSchema.parse(usersResponse satisfies GetUsersResponse);
    },
    ...options,
  });
}